import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';

import {
  Grid,
  MenuItem
} from "@material-ui/core";
import { SelectValidator, TextValidator } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";

import { DESTINOS_COMPROBANTE, PROCEDENCIA, TRAMITE_COMPROBANTE_DOCUMENTO } from '../../../../../utils/constants';
import ValidatedDatePicker from '../../../../compartidos/ValidatedDatePicker';
import Buscador from '../../../../../actions/ui/Buscador';
import { useState } from 'react';

export const DocumentosForm = ({
  formValues,
  handleInputChange,
  setearValor,
  conEmbargo,
  toggleEmbargo
}) => {
  const { procedencia } = useSelector(state => state.mesaEntrada);
  const [afiliado, setAfiliado] = useState(null);

  const tramiteReintegro = formValues.idTramite === TRAMITE_COMPROBANTE_DOCUMENTO.REINTEGRO;

  useEffect(() => {
    switch (formValues.idTramite) {
      case TRAMITE_COMPROBANTE_DOCUMENTO.CARTA_DOCUMENTO:
        setearValor("idDestino", DESTINOS_COMPROBANTE.SECRETARIA_OSPEDYC);
        break
      case TRAMITE_COMPROBANTE_DOCUMENTO.CARTA_DOCUMENTO_HOSPITALES:
      case TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_TESORERIA:
        setearValor("idDestino", DESTINOS_COMPROBANTE.TESORERIA);
        break
      case TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_AFILIACIONES:
        setearValor("idDestino", DESTINOS_COMPROBANTE.AFILIACIONES);
        break
      case TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_COMPRAS:
        setearValor("idDestino", DESTINOS_COMPROBANTE.COMPRAS);
        break
      case TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_RRHH:
        setearValor("idDestino", DESTINOS_COMPROBANTE.RRHH);
        break
      case TRAMITE_COMPROBANTE_DOCUMENTO.DOCUMENTACION_SUR:
        setearValor("idDestino", DESTINOS_COMPROBANTE.REINTEGRO_SUR);
        break
      case TRAMITE_COMPROBANTE_DOCUMENTO.EMBARGO:
        setearValor("idDestino", DESTINOS_COMPROBANTE.RRHH);
        setearValor("idProcedencia", PROCEDENCIA.OTRAS_AREAS);
        break
      default:
        setearValor("idDestino", DESTINOS_COMPROBANTE.SECRETARIA_ADMINISTRATIVA);
        break
    }

    if (formValues.idTramite !== TRAMITE_COMPROBANTE_DOCUMENTO.EMBARGO) {
      setearValor("idProcedencia", PROCEDENCIA.MAIL);
    }
  }, [formValues.idTramite, conEmbargo]);

  useEffect(() => {!afiliado && setearValor("idAfiliado", "");}, [afiliado]);
  
  return (
    <>
      {conEmbargo ? (
        <Grid item xs={12}>
          <Grid container justify='space-between'>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth
                  margin="normal"
                  label="Fecha Carga"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  maxDate={new Date()}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(formValues.fechaCarga).isValid()
                      ? moment(formValues.fechaCarga)
                      : moment().format()
                  }
                  onChange={(date) => {
                    setearValor("fechaCarga", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  disabled
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth
                  margin="normal"
                  label="Fecha Recepción"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  minDate={new Date(moment().add(-30, 'days').format())}
                  maxDate={new Date(moment().format())}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(formValues.fechaRecepcion).isValid()
                      ? moment(formValues.fechaRecepcion)
                      : moment().format()
                  }
                  onChange={(date) => {
                    setearValor("fechaRecepcion", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid item xs={4}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                fullWidth
                margin="normal"
                label="Fecha Carga"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                maxDate={new Date()}
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={
                  moment(formValues.fechaCarga).isValid()
                    ? moment(formValues.fechaCarga)
                    : moment().format()
                }
                onChange={(date) => {
                  setearValor("fechaCarga", date);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                disabled
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={4}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                fullWidth
                margin="normal"
                label="Fecha Recepción"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                minDate={new Date(moment().add(-30, 'days').format())}
                maxDate={new Date(moment().format())}
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={
                  moment(formValues.fechaRecepcion).isValid()
                    ? moment(formValues.fechaRecepcion)
                    : moment().format()
                }
                onChange={(date) => {
                  setearValor("fechaRecepcion", date);
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </>
      )}
      {!conEmbargo && (
        <Grid item xs={4}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                fullWidth
                margin="normal"
                label="Fecha Carta"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={
                  moment(formValues.fechaCarta).isValid()
                    ? moment(formValues.fechaCarta)
                    : null
                }
                onChange={(date) => setearValor('fechaCarta', date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
              />
            </MuiPickersUtilsProvider>
        </Grid>
      )}
      <Grid item xs={12}>
        {tramiteReintegro && (
            <Grid item xs={12}>
              <Buscador 
                value={afiliado}
                variant="outlined"
                setValue={(val) => {
                  setAfiliado(val);
                  setearValor("idAfiliado", val?.id_afiliado);
                }}
                margin
                label="Afiliado" 
                endpoint={(texto) => `Afiliados/traerPorNombreoDNIoNroAfi/${texto.replace("/", "__")}/Todos/Todos`}
                noOptionText={"No se encuentran afiliados"}
                filterOptions={options => (options.filter(option => moment(option?.fecha_baja).format() >= moment().format()))}
                getOptionLabel={(option) =>`${option.apellido_y_nombre} - N° Carnet: ${option.carnet} - N° Cuil: ${option.cuil} - DNI: ${option.nro_doc}`}
                renderOption={(option) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>
                      {`${option.apellido_y_nombre}`}</span>
                    <span style={{fontSize: 12}}>
                      {` Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                    </span>
                  </div>
                )}
                validators={{
                  values: ["required"],
                  msgs: ["Este campo es obligatorio"],
                }}
              />
            </Grid>
          )}
        <Grid container justify='space-between' spacing={2}>
          <Grid item xs={conEmbargo ? 6 : 4}>
            <SelectValidator
              variant="outlined"
              fullWidth
              margin="normal"
              label="Procedencia"
              name="idProcedencia"
              value={formValues.idProcedencia}
              onChange={handleInputChange}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
              validators={["required"]}
              errorMessages={["Este campo es obligatorio"]}
            >
              {procedencia.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
            </SelectValidator>
          </Grid>
          <Grid item xs={conEmbargo ? 6 : 4}>
            {
              conEmbargo ? (
                <TextValidator
                  variant="outlined"
                  margin='normal'
                  fullWidth
                  label="CUIT / CUIL"
                  autoComplete="off"
                  name="cuit"
                  value={formValues.cuit}
                  onChange={handleInputChange}
                  type='number'
                  validators={[
                    "required",
                    "isNumber",
                    "minStringLength:11",
                    "maxStringLength:11"
                  ]}
                  errorMessages={[
                    "Este campo es obligatorio",
                    "Solo números",
                    "Tiene que ser 11 caracteres",
                    "Tiene que ser 11 caracteres"
                  ]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              ) : (
                <TextValidator
                  variant="outlined"
                  margin='normal'
                  fullWidth
                  label="Folios"
                  autoComplete="off"
                  name="folios"
                  value={formValues.folios}
                  onChange={handleInputChange}
                  type='number'
                  validators={[
                    "required",
                    "isNumber",
                  ]}
                  errorMessages={[
                    "Este campo es obligatorio",
                    "Solo números",
                  ]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              )
            }
          </Grid>
          <Grid item xs={12}>
            {
              conEmbargo ? (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextValidator
                      variant="outlined"
                      margin='normal'
                      fullWidth
                      label="CBU Embargo"
                      autoComplete="off"
                      name="cbuEmbargo"
                      value={formValues.cbuEmbargo}
                      onChange={handleInputChange}
                      type='number'
                      validators={[
                        "required",
                        "isNumber",
                        "minStringLength:22",
                        "maxStringLength:22"
                      ]}
                      errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números",
                        "Tiene que ser 22 caracteres",
                        "Tiene que ser 22 caracteres"
                      ]}
                      InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextValidator
                      variant="outlined"
                      margin='normal'
                      fullWidth
                      label="Importe"
                      autoComplete="off"
                      name="importe"
                      value={formValues.importe}
                      onChange={handleInputChange}
                      type='number'
                      validators={[
                        "required",
                        "isNumber",
                      ]}
                      errorMessages={[
                        "Este campo es obligatorio",
                        "Solo números",
                      ]}
                      InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <TextValidator
                  multiline
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  label="Entregado Por"
                  name="entregadoPor"
                  value={formValues.entregadoPor}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              )
            }
          </Grid>
          <Grid item xs={12}>
            {
              conEmbargo ? (
                <TextValidator
                  multiline
                  fullWidth
                  rows={2}
                  variant="outlined"
                  margin="normal"
                  label="Autos"
                  name="autos"
                  value={formValues.autos}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 400 }}
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />) : (
                <TextValidator
                  multiline
                  fullWidth
                  rows={4}
                  variant="outlined"
                  margin="normal"
                  label="Carátula"
                  name="caratula"
                  value={formValues.caratula}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 400 }}
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              )
            }
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
